export default
{
  title: ['Closet virtual', 'Virtual closet', 'Armario virtual'],
  pic: ['Foto', 'Photo', 'Foto'],
  of: ['de', 'of', 'de'],
  notConfig: [
    'Quer ganhar tempo e ter muitos looks prontinhos no seu App?\nMe manda uma mensagem e vamos criar essas combinações juntas!',
    'Want to save time and have many looks ready in your App?\nSend me a message and let\'s create these combinations together!',
    '¿Quiere ahorrar tiempo y tener muchos looks listos en su aplicación?\n¡Envíame un mensaje y creemos estas combinaciones juntos!'
  ],
  notConfSendLink: ['Clica aqui', 'Click here', 'Haga clic aquí'],
  notConfSendMessage: [
    ' e me envia um WhatsApp!',
    ' and send me a WhatsApp!',
    ' y envíame un WhatsApp!'
  ],
  galeryBack: ['Galeria', 'Gallery', 'Galería'],
  _default: ['Minhas fotos', 'My photos', 'Mis fotos']
}



// WEBPACK FOOTER //
// ./src/constants/Closet.js